<template>
    <div v-if="alert.visible" :class="['alert mt-3 alert-' + alert.type]" role="alert">
        <strong class="a-msg">
            {{ alert.message }}
            <router-link v-if="alert.linkText && alert.linkRoute" :to="alert.linkRoute"><strong>{{ alert.linkText }}</strong></router-link>
        </strong>
        <span class="close-a" v-on:click="closeAlert">
			<font-awesome-icon :icon="['fas','circle-xmark']"/>
		</span>
    </div>
</template>

<script src="./AlertScript.vue"/>